import UserComment from "../UserComment";
import ExternalUserComment from "../ExternalUserComment";
import ReviewCommentInput from "../ReviewCommentInput";
import FileComment from "../FileComment";
import ExternalFileComment from "../ExternalFileComment";
import roles from "../../models/Roles";

const ValuerOverviewMessenger = (props) => {
    const profileRole = props.profileRole;
    const history = props.history;
    const summaryId = props.summaryId;
    const getHistory = props.getHistory;

    return (
        <>
            <div className="valuer-messenger-container">
                <div className="valuation-overview-grid-rows valuer">
                    {history && history.map((entry) => {
                        return(
                            <>
                                {entry.type_id === 1  ?
                                    <>
                                        <div className="valuation-comment-row-container">
                                            {entry.entry_user.role_id === roles.ROLE_VALUER ?
                                                <UserComment comment={entry.comment}
                                                             date={entry.entry_date}
                                                             user={entry.entry_user}/>
                                                :
                                                <ExternalUserComment comment={entry.comment}
                                                                     date={entry.entry_date}
                                                                     user={entry.entry_user}
                                                />
                                            }
                                        </div>
                                    </>
                                    : null
                                }
                                {entry.type_id === 5  ?
                                    <>
                                        <div className="valuation-comment-row-container">
                                            {entry.entry_user.role_id === roles.ROLE_VALUER ?
                                                <FileComment comment={entry.comment}
                                                             date={entry.entry_date}
                                                             summary_id={summaryId}
                                                             valuerChat={false}
                                                             user={entry.entry_user}
                                                />
                                                :
                                                <ExternalFileComment comment={entry.comment}
                                                                     date={entry.entry_date}
                                                                     summary_id={summaryId}
                                                                     roleId={entry.entry_user.role_id}
                                                                     valuerChat={false}
                                                                     user={entry.entry_user}
                                                />
                                            }
                                        </div>
                                    </>
                                    : null
                                }
                            </>
                        )
                    })}
                </div>
                <ReviewCommentInput summaryId={summaryId}
                                    getHistory={getHistory}
                                    view={"valuer"}/>
            </div>

        </>
    )
}

export default ValuerOverviewMessenger